<template>
    <div>
        <v-dialog v-model="dialog" persistent scrollable width="600">

            <v-card>

                <v-card-title>
                    Informations détaillées
                    <v-spacer/>
                    <v-icon @click="dialog = false">mdi-close</v-icon>
                </v-card-title>

                <v-divider/>

                <v-card-text class="pa-10">


                    <v-simple-table class="rounded-lg table-border">
                        <template v-slot:default>
                            <tbody>

                            <tr class="grey lighten-5">
                                <td class="font-weight-medium">Compte</td>
                                <td>
                                    <v-chip v-if="regional.is_active"
                                            class="font-weight-medium bg-success-subtle"
                                            small
                                            text-color="success">Actif
                                    </v-chip>

                                    <v-chip v-else
                                            class="font-weight-medium bg-red-subtle"
                                            small
                                            text-color="red">Inactif
                                    </v-chip>
                                </td>
                            </tr>

                            <tr>
                                <td class="font-weight-medium">Photo</td>
                                <td>
                                    <v-avatar size="38" v-if="regional.photo">
                                        <v-img :src="$baseUrl + regional.photo"
                                               class="zoom-pointer"
                                               @click="$refs.lightbox.open(regional.photo)"></v-img>
                                    </v-avatar>

                                    <v-avatar v-else
                                              :class="$func.randomColor()"
                                              class="font-weight-medium"
                                              size="38">
                                        {{$func.avatarName(regional.name)}}
                                    </v-avatar>
                                </td>
                            </tr>

                            <tr class="grey lighten-5">
                                <td class="font-weight-medium">Nom</td>
                                <td>
                                    {{ regional.name }}
                                </td>
                            </tr>

                            <tr>
                                <td class="font-weight-medium">Email</td>
                                <td>
                                    <a :href="'mailto:'+regional.email"
                                       class="orange--text">
                                        {{ regional.email }}
                                    </a>
                                </td>
                            </tr>

                            <tr class="grey lighten-5">
                                <td class="font-weight-medium">N°Téléphone</td>
                                <td>
                                    {{ regional.phone }}
                                </td>
                            </tr>

                            <tr v-if="view !=='animator' && view !=='supervisor'">
                                <td class="font-weight-medium">Wilaya</td>
                                <td>
                                    {{ regional.city ? regional.city.name : '-' }}
                                </td>
                            </tr>

                            <tr v-if="view !=='animator' && view !=='supervisor'" class="grey lighten-5">
                                <td class="font-weight-medium">Région</td>
                                <td>
                                    {{ regional.region ? regional.region.name : '-' }}
                                </td>
                            </tr>

                            <tr v-if="view !=='animator' && view !=='supervisor'">
                                <td class="font-weight-medium">Commune</td>
                                <td>
                                    {{ regional.municipality ? regional.municipality.name : '-' }}
                                </td>
                            </tr>

                            <tr v-if="view !=='animator' && view !=='supervisor'" class="grey lighten-5">
                                <td class="font-weight-medium">Adresse</td>
                                <td>
                                    {{ regional.address }}
                                </td>
                            </tr>

                            <tr>
                                <td class="font-weight-medium">Date de création</td>
                                <td>
                                    {{ regional.created_at }}
                                </td>
                            </tr>

                            </tbody>
                        </template>
                    </v-simple-table>

                </v-card-text>
            </v-card>
        </v-dialog>

        <Lightbox ref="lightbox"/>

    </div>
</template>

<script>

export default {
    data() {
        return {
            dialog: false,
            view: '',
            regional: {}
        }
    },
    methods: {
        open(regional, view) {
            this.view = view
            this.regional = regional
            this.dialog = true
        },
    },
}
</script>

<style scoped>

</style>